import React, { Component } from "react";
import AntdInput, { InputProps } from "antd/lib/input";
import PagePoint from "../page-point/pagePointEnhanced";
import { ConfigConsumer, ConfigConsumerEProps } from "../config-provider";
import "antd/lib/input/style";

interface FIProps extends InputProps {
  forwardedRef?: any;
}
const { TextArea, Search, Group, Password } = AntdInput;
class FdxInput extends Component<FIProps> {
  render() {
    const { forwardedRef, ...rest } = this.props;
    return <AntdInput ref={forwardedRef} {...rest} />;
  }
}

const Input: any = React.forwardRef((props: FIProps, ref) => {
  return (
    <ConfigConsumer>
      {({ pagePoint }: ConfigConsumerEProps) =>
        pagePoint ? (
          <PagePoint
            compType="Input"
            {...props}
            render={eventprops => (
              <FdxInput {...props} {...eventprops} forwardedRef={ref} data-ui-role='Input'/>
            )}
          ></PagePoint>
        ) : (
          <FdxInput {...props} forwardedRef={ref} />
        )
      }
    </ConfigConsumer>
  );
});
Input.TextArea = TextArea;
Input.Search = Search;
Input.Group = Group;
Input.Password = Password;

export default Input;



// WEBPACK FOOTER //
// ./src/components/input/index.tsx